const prefix = 'iam-users';

const SET_USERS = `${prefix}/SET_USERS`;

const SET_TOTAL = `${prefix}/SET_TOTAL`;

const SET_LOADING = `${prefix}/SET_LOADING`;

const RESET = `${prefix}/RESET`;

export { SET_USERS, SET_TOTAL, RESET, SET_LOADING };
